export const articlesPart2 = [
  {
    id: "antalya-gezilecek-yerler",
    title: "Antalya Gezi Rehberi: Antik Kentlerden Gizli Kanyonlara 40 Büyüleyici Rota",
    category: "Şehir Rehberi",
    author: "Deniz Yıldız",
    date: "2026-04-08",
    readTime: "20 dk",
    shortDesc: "Türkiye'nin turizm başkentinde Kaleiçi'nin tarihi sokaklarından Likya'nın antik kentlerine, Köprülü Kanyon'un rafting rotalarından Akdeniz'in en güzel plajlarına uzanan 40 duraktan oluşan kapsamlı bir gezi rehberi.",
    content: `Türkiye'nin turizm başkenti Antalya, sadece lüks resort otelleri ve plajlarıyla değil, binlerce yıllık tarihi, antik kentleri, şelaleleri ve kanyonlarıyla da dünya çapında bir destinasyondur.

## Antalya Merkez ve Çevresi

**1. Kaleiçi (Old Town):** Antalya'nın kalbi. Hadrian Kapısı'ndan girilen, dar sokakları, Osmanlı konakları ve Yivli Minare ile gün boyu kaybolmak isteyeceğiniz tarihi merkez.

**2. Hadrian Kapısı:** MS 130 yılında Roma İmparatoru Hadrianus'un Antalya'yı ziyareti anısına yapılan muazzam mermer tak.

**3. Antalya Müzesi:** Dünyanın en önemli arkeoloji müzelerinden biri.

**4. Düden Şelalesi:** Doğrudan Akdeniz'e dökülen muhteşem şelale.

## Kemer ve Batı Antalya

**9. Phaselis Antik Kenti:** Çam ağaçlarının doğrudan denize indiği üç antik limanı olan eşsiz yer.

**10. Olympos:** Sırt çantalı gezginlerin, ağaç evlerin ve hippi kültürünün merkezi.

**11. Çıralı ve Yanartaş:** Binlerce yıldır sönmeden yanan mitolojik ateş Yanartaş.

## Kaş ve Kalkan Bölgesi

**16. Kaş Meydanı:** Dar sokakları, cumbalı evleri ve begonvilleriyle Türkiye'nin en karakteristik tatil beldesi.

**17. Kaputaş Plajı:** Kanyon ağzında yer alan turkuaz renkli ikonik plaj.

## Doğu Antalya

**23. Perge Antik Kenti:** Sütunlu caddeleri, stadyumu ve hamamıyla Anadolu'nun en düzenli Roma şehirlerinden biri.

**24. Aspendos Antik Tiyatrosu:** 15.000 kişi kapasiteli, dünyanın akustik olarak en iyi korunmuş antik tiyatrosu.

**26. Köprülü Kanyon Milli Parkı:** Rafting denilince Türkiye'de akla ilk gelen yer.`,
    image: "https://readdy.ai/api/search-image?query=Antalya%20Kaleici%20Old%20town%20harbor%20marina%20Mediterranean%20sea%20Kaputas%20beach%20Turkey&width=800&height=450&seq=art-ant-40&orientation=landscape",
    tags: ["Antalya", "Gezilecek Yerler", "Akdeniz", "Gezi Rehberi"],
    featured: false,
  },
  {
    id: "izmir-gezilecek-yerler",
    title: "İzmir Gezi Rehberi: Kemeraltı'ndan Alaçatı'ya Ege'nin İncisinde 30 Durak",
    category: "Şehir Rehberi",
    author: "Zeynep Çelik",
    date: "2026-04-07",
    readTime: "15 dk",
    shortDesc: "Tarihi Saat Kulesi ve Kemeraltı Çarşısı'ndan Efes antik kentine, Şirince'nin bağ bahçelerinden Alaçatı'nın taş sokaklarına uzanan İzmir'in en kapsamlı gezi rehberi.",
    content: `Türkiye'nin üçüncü büyük şehri İzmir, çağdaş yaşam tarzı, palmiyelerle süslü kordon boyu ve antik çağlardan kalan devasa miraslarıyla eşsizdir.

## İzmir Merkez

**1. İzmir Saat Kulesi ve Konak Meydanı:** 1901'de II. Abdülhamit'in tahta çıkışının 25. yılı anısına yaptırılan, İzmir'in simgesidir.

**2. Tarihi Kemeraltı Çarşısı:** 400 yıllık tarihiyle, baharatçılardan kuyumculara kadar gün boyu kaybolacağınız tarihi alışveriş merkezi.

**4. Tarihi Asansör:** Mithatpaşa ile Halil Rıfat Paşa semtleri arasındaki 58 metrelik kot farkını aşmak için 1907'de yapılan asansör.

**5. Alsancak Kordon Boyu:** Çimlerinde oturup çekirdek çitlemek ve gün batımını izlemek için İzmir'in yaşam damarı.

## Selçuk, Efes ve Şirince

**11. Efes Antik Kenti:** UNESCO Dünya Mirası olan Efes; Celsus Kütüphanesi ve 25.000 kişilik dev tiyatrosuyla dünyanın en iyi korunmuş antik Roma şehirlerinden biridir.

**13. Şirince Köyü:** Meyve şarapları ve beyaz badanalı eski Rum evleriyle İzmir'in en çok turist çeken masalsı köyü.

## Çeşme ve Alaçatı

**16. Alaçatı:** Taş evleri, dar sokakları, değirmenleri ve dünya çapındaki rüzgar sörfü merkezleriyle Türkiye'nin en sosyetik tatil beldesi.

**17. Alaçatı Kalesi ve Marina:** 1508 yılında II. Bayezid tarafından yaptırılan Ceneviz mimarisine sahip kale.`,
    image: "https://readdy.ai/api/search-image?query=Izmir%20clock%20tower%20Konak%20square%20Alacati%20stone%20houses%20Aegean%20sea%20Turkey%20city&width=800&height=450&seq=art-izm-30&orientation=landscape",
    tags: ["İzmir", "Ege", "Gezilecek Yerler", "Gezi Rehberi"],
    featured: false,
  },
  {
    id: "ankara-gezilecek-yerler",
    title: "Ankara Gezi Rehberi: Anıtkabir'den Hamamönü'ne Başkentin Tarihi ve Modern Yüzü",
    category: "Şehir Rehberi",
    author: "Mert Demir",
    date: "2026-04-05",
    readTime: "14 dk",
    shortDesc: "Türkiye'nin başkentinde Anıtkabir'den Anadolu Medeniyetleri Müzesi'ne, restore edilmiş Hamamönü sokaklarından Eymir Gölü'nün huzuruna uzanan kapsamlı bir gezi rehberi.",
    content: `Türkiye'nin başkenti Ankara, pek çok kişinin sandığının aksine yalnızca bürokratik bir şehir değil; zengin tarihi, dünya standartlarındaki müzeleri ve çevre doğasıyla keşfedilmeyi bekleyen bir destinasyondur.

## Tarihi ve Kültürel Noktalar

**1. Anıtkabir:** Türkiye Cumhuriyeti'nin kurucusu Mustafa Kemal Atatürk'ün anıt mezarı.

**2. Anadolu Medeniyetleri Müzesi:** UNESCO tarafından "Yılın Müzesi" seçilen bu müze, Paleolitik dönemden Osmanlı'ya kadar Anadolu'nun tüm uygarlıklarına ait eserleri barındırır.

**3. Ankara Kalesi ve İç Kale:** Galatlar tarafından kurulan, şehrin en yüksek noktasından panoramik manzara sunar.

**4. Hamamönü:** Ankara Kalesi'nin eteklerinde, 19. yüzyıl Osmanlı konaklarının restore edildiği tarihi semt.

## Doğa ve Rekreasyon Alanları

**9. Eymir Gölü:** Şehir merkezine 20 km uzaklıkta, ormanlık alanda yer alan yapay göl.

**10. Mogan Gölü:** Eymir'in güneyinde, daha sakin ve daha az kalabalık bir göl.

**11. Atatürk Orman Çiftliği:** Atatürk'ün kurduğu, içinde çiftlik, bira fabrikası ve piknik alanları bulunan geniş yeşil alan.`,
    image: "https://readdy.ai/api/search-image?query=Ankara%20Turkey%20Ataturk%20Mausoleum%20Anitkabir%20Hamamonu%20historical%20district%20capital%20city%20landscape&width=800&height=450&seq=art-ank-15&orientation=landscape",
    tags: ["Ankara", "Başkent", "Gezilecek Yerler", "Tarih"],
    featured: false,
  },
  {
    id: "trabzon-gezilecek-yerler",
    title: "Trabzon Gezi Rehberi: Sümela Manastırı'ndan Uzungöl'e Karadeniz'in Efsanevi Şehri",
    category: "Gezi Rehberi",
    author: "Ahmet Yıldız",
    date: "2026-04-04",
    readTime: "13 dk",
    shortDesc: "Pontus Krallığı'nın kadim başkentinde kayalıklara oyulmuş Sümela Manastırı'ndan sisli Uzungöl'e uzanan kapsamlı bir gezi rehberi.",
    content: `Karadeniz'in en önemli liman şehri Trabzon, Pontus Krallığı'nın başkentliğini yapmış, İpek Yolu'nun önemli bir durağı olmuştur.

## Tarihi ve Kültürel Noktalar

**1. Sümela Manastırı:** Trabzon'un ve Karadeniz'in simgesi. MS 386 yılında dik bir kayalığa oyularak inşa edilen bu Ortodoks manastırı, 1200 metre yükseklikte yer alır.

**2. Trabzon Ayasofyası:** İstanbul'daki Ayasofya'dan önce inşa edilen, Bizans döneminden kalma tarihi kilise.

**3. Trabzon Kalesi:** Şehrin tepesinde yer alan, Pontus Krallığı döneminden kalma tarihi kale.

## Doğa Harikası Noktalar

**6. Uzungöl:** Trabzon'un en ünlü doğa destinasyonu. Çam ormanlarıyla çevrili, sabah sisinin büyülediği dağ gölü.

**7. Boztepe:** Şehrin üzerinde yükselen, Trabzon ve Karadeniz'i kuşbakışı gören seyir terası.

## Gastronomi

**11. Trabzon Meydanı ve Çarşısı:** Mısır ekmeği, hamsi tava, kuymak ve Trabzon hurması gibi yöresel lezzetleri tatmak için en iyi adres.`,
    image: "https://readdy.ai/api/search-image?query=Trabzon%20Sumela%20Monastery%20Black%20Sea%20Turkey%20Uzungol%20lake%20mountain%20forest%20Karadeniz&width=800&height=450&seq=art-tra-12&orientation=landscape",
    tags: ["Trabzon", "Karadeniz", "Sümela", "Gezilecek Yerler"],
    featured: false,
  },
  {
    id: "konya-gezilecek-yerler",
    title: "Konya Gezi Rehberi: Mevlana'nın Şehrinde Manevi ve Tarihi Bir Yolculuk",
    category: "Gezi Rehberi",
    author: "Elif Kaya",
    date: "2026-04-03",
    readTime: "12 dk",
    shortDesc: "Mevlana Müzesi ve sema törenlerinden Selçuklu mirasına, 9.500 yıllık Çatalhöyük'ten Beyşehir Gölü'nün huzuruna uzanan kapsamlı bir gezi rehberi.",
    content: `Konya, Mevlana Celaleddin Rumi'nin yaşadığı ve türbesinin bulunduğu, Selçuklu İmparatorluğu'nun başkentliğini yapmış şehirdir.

## Tarihi ve Manevi Noktalar

**1. Mevlana Müzesi (Türbesi):** Konya'nın ve Türkiye'nin en çok ziyaret edilen müzelerinden biri.

**2. Alaeddin Camii:** Selçuklu döneminin en önemli camilerinden biri.

**3. Karatay Medresesi:** 1251 yılında inşa edilen ve bugün çini müzesi olarak kullanılan Selçuklu yapısı.

## Çevre Destinasyonlar

**7. Çatalhöyük:** Konya'ya 52 km uzaklıkta, MÖ 7500-5700 yıllarına tarihlenen UNESCO Dünya Mirası.

**8. Sille Köyü:** Konya'ya 8 km uzaklıkta, tarihi Rum evleri ve kaya kiliseleriyle ünlü antik köy.

**9. Beyşehir Gölü:** Türkiye'nin üçüncü büyük gölü.

## Sema Töreni

**11. Mevlana Kültür Merkezi:** Her Cumartesi akşamı düzenlenen sema töreni, Konya'nın en özel deneyimlerinden biridir.`,
    image: "https://readdy.ai/api/search-image?query=Konya%20Mevlana%20Museum%20green%20dome%20Turkey%20Seljuk%20architecture%20whirling%20dervishes%20spiritual%20city&width=800&height=450&seq=art-kon-11&orientation=landscape",
    tags: ["Konya", "Mevlana", "Selçuklu", "Gezilecek Yerler"],
    featured: false,
  },
  {
    id: "gaziantep-gezilecek-yerler",
    title: "Gaziantep'te Gezilecek Yerler: Zeugma'dan Halfeti'ye UNESCO Şehrinin Tarihi Hazineleri",
    category: "Şehir Rehberi",
    author: "Selin Arslan",
    date: "2026-04-02",
    readTime: "13 dk",
    shortDesc: "Dünyanın en büyük mozaik müzesinden 2.000 yıllık kaleye, Bakırcılar Çarşısı'nın el sanatları atölyelerinden Fırat kıyısındaki romantik Halfeti'ye kapsamlı rehber.",
    content: `Gaziantep, UNESCO Gastronomi Şehri unvanının yanı sıra, dünyanın en büyük mozaik müzesine ve 2000 yıllık bir kaleye sahip bir şehirdir.

## Müzeler ve Tarihi Yapılar

**1. Zeugma Mozaik Müzesi:** Dünyanın en büyük mozaik müzesi. "Çingene Kızı" mozaiği dünyanın en ünlü mozaiklerinden biridir.

**2. Gaziantep Kalesi:** Şehrin merkezinde, Roma ve Bizans dönemlerinden kalma tarihi kale.

**4. Emine Göğüş Mutfak Müzesi:** Gaziantep mutfak kültürünü anlatan özgün müze.

## Tarihi Çarşılar ve Hanlar

**6. Bakırcılar Çarşısı:** Yüzyıllardır bakır işçiliğinin sürdürüldüğü tarihi çarşı.

**8. Tahmis Kahvesi:** 1635 yılında kurulan, Türkiye'nin en eski kahvehanelerinden biri.

## Çevre Destinasyonlar

**10. Halfeti:** Fırat Nehri kıyısında, su altında kalan eski köyün üzerine kurulu romantik kasaba.

**12. Yesemek Heykel Atölyesi:** Hitit döneminden kalma, dünyanın en büyük açık hava heykel atölyesi.`,
    image: "https://readdy.ai/api/search-image?query=Gaziantep%20Zeugma%20mosaic%20museum%20castle%20Turkey%20historical%20city%20baklava%20pistachio&width=800&height=450&seq=art-gaz-14&orientation=landscape",
    tags: ["Gaziantep", "Zeugma", "Gezilecek Yerler", "Güneydoğu"],
    featured: false,
  },
  {
    id: "mardin-gezilecek-yerler",
    title: "Mardin'de Gezilecek Yerler: Mezopotamya'nın Taş Şehrinde Tarihi ve Manevi Bir Yolculuk",
    category: "Şehir Rehberi",
    author: "Zeynep Çelik",
    date: "2026-04-01",
    readTime: "12 dk",
    shortDesc: "Sarı taş evlerin Mezopotamya ovasına hakim olduğu Mardin'de Deyrulzafaran Manastırı'ndan Mor Gabriel'e uzanan kapsamlı bir gezi rehberi.",
    content: `Mardin, Mezopotamya ovasına hakim bir tepe üzerinde kurulu, sarı taş evleri, manastırları ve çok kültürlü yapısıyla Türkiye'nin en özgün şehirlerinden biridir.

## Tarihi Şehir Merkezi

**1. Mardin Kalesi:** Şehrin en yüksek noktasında yer alan, Mezopotamya ovasını gören tarihi kale.

**2. Ulu Cami (Mardin Ulu Camii):** 12. yüzyılda Artuklular tarafından inşa edilen tarihi cami.

**4. Mardin Müzesi:** Eski bir Osmanlı konağında kurulan müze.

**6. Tarihi Çarşı ve Bakırcılar Sokağı:** Dar sokakları, taş kemerli dükkanları ve el sanatları atölyeleriyle Mardin'in en canlı bölgesi.

## Manastırlar ve Kiliseler

**7. Deyrulzafaran Manastırı (Safran Manastırı):** MS 493 yılında kurulan, Süryani Ortodoks Kilisesi'nin önemli bir merkezi.

**8. Mor Gabriel Manastırı:** Midyat yakınlarında, MS 397 yılında kurulan ve dünyanın hâlâ faal olan en eski Hristiyan manastırlarından biri.

## Midyat ve Çevresi

**10. Midyat:** Mardin'e 70 km uzaklıkta, taş evleri ve gümüş işçiliğiyle ünlü ilçe.

**12. Dara Antik Kenti:** Mardin'e 30 km uzaklıkta, Roma döneminden kalma yeraltı mezarları ve su sarnıçlarıyla önemli bir arkeolojik alan.`,
    image: "https://readdy.ai/api/search-image?query=Mardin%20Turkey%20stone%20houses%20Mesopotamia%20valley%20Deyrulzafaran%20monastery%20historical%20city%20sunset&width=800&height=450&seq=art-mar-12&orientation=landscape",
    tags: ["Mardin", "Güneydoğu", "Manastır", "Gezilecek Yerler"],
    featured: false,
  },
  {
    id: "kocaeli-gezilecek-yerler",
    title: "Kocaeli Gezi Rehberi: Kartepe'den Kandıra'ya Marmara'nın Gizli Doğa Cenneti",
    category: "Gezi Rehberi",
    author: "Emre Can",
    date: "2026-04-11",
    readTime: "11 dk",
    shortDesc: "İstanbul'a 1 saat uzaklıkta, Kartepe'nin karlı yamaçlarından Sapanca Gölü kıyılarına, Kandıra'nın el değmemiş Karadeniz sahillerinden Seka Park'ın yeşil koridorlarına uzanan Kocaeli'nin en güzel 18 rotası.",
    content: `Kocaeli, Türkiye'nin en büyük sanayi şehirlerinden biri olmasına rağmen, Kartepe dağı, Sapanca Gölü, Kandıra sahilleri ve Hereke gibi doğal ve tarihi güzellikleriyle hafta sonu kaçamakları için mükemmel bir destinasyondur.

## Dağ ve Orman Rotaları

**1. Kartepe Kayak Merkezi:** İstanbul'a sadece 1,5 saat uzaklıkta, Türkiye'nin en erişilebilir kayak merkezlerinden biri.

**2. Kartepe Teleferik:** Deniz seviyesinden 1640 metre yüksekliğe çıkan teleferik.

**3. Kartepe Orman Yürüyüş Parkurları:** Çam ve kayın ormanları arasında uzanan çeşitli güzergahlarda yürüyüş.

**4. Maşukiye Şelaleleri:** Sapanca Gölü'nün kuzeyinde, Maşukiye bölgesinde birçok küçük şelale.

## Göl ve Su Kenarı Rotaları

**5. Sapanca Gölü Kıyısı:** Kocaeli ve Sakarya sınırında yer alan Sapanca Gölü, kano, kayak ve bisiklet turu için mükemmel.

## Şehir İçi Noktalar

**8. Seka Park:** İzmit şehir merkezinde, eski Seka kağıt fabrikasının arazisi üzerine kurulmuş Türkiye'nin en büyük şehir parklarından biri. Giriş ücretsizdir.

## Tarihi ve Kültürel Noktalar

**12. Hereke Halı Fabrikası:** 19. yüzyılda Osmanlı sarayları için üretilmeye başlanan dünyaca ünlü Hereke halılarının üretildiği fabrika.

**13. Gebze Çoban Mustafa Paşa Külliyesi:** 16. yüzyılda inşa edilen büyük Osmanlı külliyesi.

## Karadeniz Sahilleri

**15. Kandıra Sahilleri:** Kocaeli'nin Karadeniz kıyısındaki Kandıra ilçesi, uzun ve temiz kumsalları ve kamp alanlarıyla özellikle yaz aylarında tercih edilir.

## Gastronomi

**18. İzmit Pişmaniyesi:** Kocaeli'nin en ünlü gastronomi ürünü olan İzmit pişmaniyesi, ince iplik şeker ve un karışımından yapılan geleneksel bir tatlıdır.`,
    image: "https://readdy.ai/api/search-image?query=Kartepe%20mountain%20Kocaeli%20Turkey%20winter%20snow%20forest%20ski%20resort%20Sapanca%20lake%20panoramic%20view&width=800&height=450&seq=art-koc-18&orientation=landscape",
    tags: ["Kocaeli", "Kartepe", "Sapanca", "Gezilecek Yerler"],
    featured: false,
  },
  {
    id: "bolu-gezilecek-yerler",
    title: "Bolu Gezi Rehberi: Abant Gölü'nden Yedigöller'e Batı Karadeniz'in Doğa Cenneti",
    category: "Gezi Rehberi",
    author: "Emre Can",
    date: "2026-04-11",
    readTime: "12 dk",
    shortDesc: "Abant Gölü'nün huzurlu kıyılarından Yedigöller'in sonbahar renkleri ve Kartalkaya'nın karlı yamaçlarına, Mudurnu'nun Osmanlı konakları ve Göynük'ün tarihi dokusuna uzanan Bolu'nun en güzel 20 rotası.",
    content: `Bolu, Batı Karadeniz'in kapısında, İstanbul ve Ankara'ya eşit uzaklıkta konumuyla Türkiye'nin en erişilebilir dört mevsim doğa destinasyonlarından biridir.

## Göller ve Su Kenarı Rotaları

**1. Abant Gölü Tabiat Parkı:** Bolu'nun simgesi. Çam ormanlarıyla çevrili, 1328 metre yükseklikte yer alan doğal göl. 7 km'lik çevre yürüyüş yolu ile dört mevsim ziyaret edilebilir.

**2. Abant Gölü Bisiklet Yolu:** Gölü çevreleyen bisiklet yolunda pedal çevirmek, hem spor hem de doğa deneyimi sunar.

**3. Gölcük Gölü:** Bolu şehir merkezine 10 km uzaklıkta, orman içinde yer alan küçük ama güzel göl.

## Milli Parklar ve Ormanlar

**5. Yedigöller Milli Parkı:** Bolu'nun Kıbrıscık ilçesinde, birbirine bağlı 7 gölden oluşan milli park. Sonbahar aylarında (Ekim-Kasım) sarı, turuncu ve kırmızı yapraklarla kaplanan ormanlar eşsiz bir manzara sunar.

## Kayak ve Kış Sporları

**8. Kartalkaya Kayak Merkezi:** Türkiye'nin en büyük ve en iyi donanımlı kayak merkezlerinden biri. İstanbul'a yaklaşık 2,5 saat uzaklıkta.

## Tarihi ve Kültürel Noktalar

**10. Mudurnu Osmanlı Evleri:** Bolu'ya 60 km uzaklıkta, Osmanlı döneminden kalma ahşap konak evleriyle ünlü tarihi ilçe.

**11. Göynük İlçesi:** Osmanlı'nın ilk dönemlerine ait tarihi yapılarıyla dikkat çeken tarihi ilçe. Akşemseddin'in türbesi burada yer almaktadır.

## Gastronomi

**16. Bolu Tereyağı:** Türkiye'nin en ünlü tereyağlarından biri olan Bolu tereyağı, şehrin en önemli gastronomi ürünüdür.

**17. Abant Alabalığı:** Abant Gölü çevresindeki restoranlarda taze alabalık yemek ayrı bir deneyimdir.`,
    image: "https://readdy.ai/api/search-image?query=Bolu%20Abant%20lake%20Turkey%20autumn%20fall%20forest%20reflection%20mountain%20Yedig%C3%B6ller%20national%20park&width=800&height=450&seq=art-bol-20&orientation=landscape",
    tags: ["Bolu", "Abant", "Yedigöller", "Gezilecek Yerler"],
    featured: false,
  },
  {
    id: "kapadokya-gezilecek-yerler",
    title: "Kapadokya'da Gezilecek Yerler: Peri Bacaları ve Yeraltı Şehirleri",
    category: "Gezi Rehberi",
    author: "Elif Kaya",
    date: "2026-03-30",
    readTime: "15 dk",
    shortDesc: "Kapadokya'da gezilecek yerler rehberi. Göreme'den Derinkuyu'ya, Ihlara Vadisi'nden Uçhisar'a Nevşehir'in eşsiz coğrafyasında en güzel rotalar.",
    content: `Kapadokya, milyonlarca yıl önce volkanik patlamalar ve erozyon sonucu oluşan peri bacaları, yeraltı şehirleri ve kaya kiliseleriyle dünyanın en eşsiz coğrafyalarından biridir.

## Göreme ve Çevresi

**1. Göreme Açık Hava Müzesi:** UNESCO Dünya Mirası. Kaya oyma kiliseler ve şapeller, içlerindeki fresklerle Hristiyan sanatının en önemli örneklerini barındırır.

**2. Uçhisar Kalesi:** Kapadokya'nın en yüksek noktası. Kaya oyma odaları ve tepesinden 360 derece panoramik manzarasıyla bölgenin en ikonik noktası.

**3. Güvercinlik Vadisi:** Kaya güvercinliklerinin oyulduğu, bisiklet ve yürüyüş için ideal vadi.

**4. Kızılçukur Vadisi:** Kırmızı kaya oluşumları ve bağ bahçeleriyle gün batımı için mükemmel.

## Yeraltı Şehirleri

**7. Derinkuyu Yeraltı Şehri:** 85 metre derinliğe inen, 20.000 kişiyi barındırabilecek kapasitedeki devasa yeraltı şehri.

**8. Kaymaklı Yeraltı Şehri:** Derinkuyu'ya göre daha geniş ama daha az derin.

## Ihlara Vadisi

**9. Ihlara Vadisi:** 14 km uzunluğundaki bu vadi, 100'den fazla kaya kilisesi ve Melendiz Çayı ile trekking tutkunları için cennet.

## Ürgüp ve Avanos

**10. Ürgüp:** Şarap mahzenleri, butik oteller ve panoramik manzarasıyla bölgenin en şık kasabası.

**11. Avanos:** Kızılırmak Nehri kıyısında, çömlek sanatıyla ünlü kasaba.`,
    image: "https://readdy.ai/api/search-image?query=Cappadocia%20Goreme%20fairy%20chimneys%20hot%20air%20balloons%20underground%20city%20Turkey%20Nevsehir%20landscape&width=800&height=450&seq=art-kap-12&orientation=landscape",
    tags: ["Kapadokya", "Nevşehir", "Peri Bacaları", "Gezilecek Yerler"],
    featured: false,
  },
  {
    id: "bursa-gezilecek-yerler",
    title: "Bursa'da Gezilecek Yerler: Osmanlı'nın İlk Başkentinde Tarihi Hanlardan Uludağ'a 25 Rota",
    category: "Gezi Rehberi",
    author: "Can Öztürk",
    date: "2026-04-06",
    readTime: "13 dk",
    shortDesc: "Koza Han'ın ipek kokusu, Yeşil Cami'nin turkuaz çinileri ve Cumalıkızık'ın 700 yıllık Osmanlı sokakları — Türkiye'nin 'Yeşil Şehri' Bursa'da 25 tarihi ve doğal rotayı keşfediyoruz.",
    content: `Osmanlı İmparatorluğu'nun ilk başkenti Bursa, zengin tarihi mirası, İskender Kebabı, kestane şekeri ve "Yeşil" unvanını hak eden doğasıyla Türkiye'nin en özel şehirlerinden biridir.

## Tarihi Şehir Merkezi ve Hanlar Bölgesi

**1. Bursa Ulu Cami:** 1399 yılında I. Bayezid tarafından yaptırılan, 20 kubbesi ve içindeki dev şadırvanıyla Osmanlı çok kubbeli cami mimarisinin ilk ve en görkemli örneği.

**2. Koza Han:** 1490 yılında yaptırılan, asırlardır ipek ticaretinin merkezi olan han.

**4. Yeşil Cami ve Yeşil Türbe:** Çelebi Mehmet tarafından yaptırılan, turkuaz ve yeşil çinileriyle büyüleyen şehrin simgesi.

**5. Tophane Saat Kulesi ve Osman Gazi / Orhan Gazi Türbeleri:** Osman Devleti'nin kurucularının yattığı türbeler.

## Doğa ve Eğlence Dağı: Uludağ

**9. Uludağ Kayak Merkezi:** Antik çağda "Olympos" olarak bilinen, Türkiye'nin en popüler kış sporları merkezi.

**10. Bursa Teleferik:** Şehir merkezinden Uludağ bölgesine 9 km'lik dünyanın en uzun kesintisiz hatlarından biriyle manzaralı bir yolculuk.

## Köyler ve Kasabalar

**13. Cumalıkızık Köyü:** UNESCO listesindeki 700 yıllık Osmanlı vakıf köyü. Taş döşeli dar sokakları ve renkli cumbalı evleriyle ünlüdür.

**14. Gölyazı (Apolyont):** Uluabat Gölü ortasında, karaya bir köprüyle bağlı şirin bir yarımada köyü.

## Göller, Parklar ve Kaplıcalar

**16. İznik Gölü ve İznik:** Çini sanatının başkenti ve Hristiyanlık için çok önemli olan İznik.

**23. Karacabey Longoz Ormanı:** Denizin, nehrin, gölün ve ormanın birleştiği nadir ekosistem.`,
    image: "https://readdy.ai/api/search-image?query=Bursa%20Ulu%20Cami%20Grand%20Mosque%20Uludag%20mountain%20Cumalikizik%20historical%20ottoman%20village%20snow&width=800&height=450&seq=art-bur-25&orientation=landscape",
    tags: ["Bursa", "Marmara", "Gezilecek Yerler", "Tarih"],
    featured: false,
  },
];
